import React from "react";
import "./WhyUs.css";
import { Link } from "react-router-dom";

const WhyUs = () => {
  const checkoutUrl = "https://learn.forgeyourpeak.in/web/checkout/698a8ef1831f481067f8b8f1";
  return (
    <div className="wrap">
      
      {/* HERO */}
      <div className="hero">
        <div className="kicker">
          WHY FORGEYOURPEAK • <b>SYSTEM-DRIVEN</b>
        </div>

        <h1>
          Most Athletes Train the Body.<br />
          We Train the System That Controls It.
        </h1>

        <p className="sub">
          ForgeYourPeak builds visual + cognitive performance using a structured framework — not random drills.
          We combine <b>measurement</b>, <b>brain-based training</b>, and <b>on-field transfer</b> so athletes improve in ways that actually show up in competition.
        </p>

        <div className="ctaRow">
          <Link className="btn primary" to="/webinar">
               Join Free Webinar </Link>
          <Link to="/ignite#waitlist" className="btn">Join Ignite Waitlist</Link>
        </div>
      </div>

      {/* DIFFERENTIATORS */}
{/* =============================== */}
{/* WHAT MAKES US DIFFERENT */}
{/* =============================== */}

<div className="section">
  <div className="pad different-wrap">
    
    <h2 className="different-title">What Makes Us Different</h2>
    <p className="different-sub">
      Four pillars that separate ForgeYourPeak from generic training programs.
    </p>

    <div className="cards">
      {[
        {
          title: "Measurement-First Approach",
          text: "We don’t guess. We measure key performance inputs and train what actually limits your speed and consistency."
        },
        {
          title: "Brain-Based Training",
          text: "Vision, hand-eye coordination, memory, anticipation, and recovery — the core drivers behind elite performance."
        },
        {
          title: "Structured Progression",
          text: "Bootcamp → Ignite → Advanced development. No confusion, no random content overload."
        },
        {
          title: "On-Field Transfer",
          text: "Every drill must translate. We focus on carryover to match situations and decision pressure — not just practice."
        }
      ].map((item, index) => (
        <div className="card different-card" key={index}>
          <div className="icon different-icon">{index + 1}</div>
          <div>
            <h3>{item.title}</h3>
            <p>{item.text}</p>
          </div>
        </div>
      ))}
    </div>

  </div>
</div>


{/* =============================== */}
{/* WHERE MOST TRAINING FALLS SHORT */}
{/* =============================== */}

<div className="section">
  <div className="pad comparison-outer">

    <h2 className="different-title">
      Where Most Training Falls Short
    </h2>

    <p className="different-sub">
      Traditional training often improves effort — but not the processing loop that determines results.
    </p>

    <div className="comp">
      
      <div className="box">
        <div className="boxHead">Typical Training</div>
        <div className="boxBody">
          <ul className="list">
            <li>Trains the body without training visual pickup</li>
            <li>Tests reaction time but ignores “when the eyes saw it”</li>
            <li>Memory drills without game context</li>
            <li>No recovery strategy for learning + consistency</li>
            <li>Lots of drills, little structure</li>
          </ul>
        </div>
      </div>

      <div className="box">
        <div className="boxHead">ForgeYourPeak</div>
        <div className="boxBody">
          <ul className="list">
            <li>Trains visual input → processing → response</li>
            <li>Builds speed with clarity and cue pickup first</li>
            <li>Improves anticipation and decision stability</li>
            <li>Integrates sleep/recovery as performance multiplier</li>
            <li>Clear levels and progression system</li>
          </ul>
        </div>
      </div>

    </div>
   

  </div>
</div>
     {/* ================= PERFORMANCE LOOP ================= */}

<div className="section">
  <div className="pad performance-box">

    <h2>The Performance Loop Model</h2>
    <p className="section-sub">
      This is the system we train — so your performance improves under speed and pressure.
    </p>

    <div className="loop-inner">
      <div className="loop-flow">
        <strong>Vision → Processing → Decision → Movement → Recovery</strong>
      </div>

      <div className="loop-steps">
        <div className="step-card">
          <h4>Vision</h4>
          <p>Clarity • Tracking • Depth</p>
        </div>

        <div className="step-card">
          <h4>Processing</h4>
          <p>Speed • Accuracy • Load control</p>
        </div>

        <div className="step-card">
          <h4>Decision</h4>
          <p>Anticipation • Choice speed</p>
        </div>

        <div className="step-card">
          <h4>Movement</h4>
          <p>Hand-eye • Timing • Execution</p>
        </div>

        <div className="step-card">
          <h4>Recovery</h4>
          <p>Sleep • Reset • Consistency</p>
        </div>
      </div>

      <p className="loop-note">
        If you want faster reactions, you don’t only train hands — you train the loop.
      </p>
    </div>

  </div>
</div>


{/* ================= BUILT BY PRACTITIONERS ================= */}

{/* ================= BUILT BY PRACTITIONERS ================= */}

<div className="section">
  <div className="pad founder-box">
    
      <h2>Built by Practitioners, Not Influencers</h2>
      <p className="section-sub">
        Short, honest credibility — focused on what matters.
      </p>

      <div className="founder-content">

        <div className="founder-photo">
          <img
            src="/hero/vevek-hero.jpeg"
            alt="Vevek Founder"
            className="founder-img"
          />
        </div>

        <div className="founder-text">
          <h4>Vevek S. • Founder, ForgeYourPeak</h4>
          <p>
            An interdisciplinary performance coach specializing in vision and cognitive training.
            ForgeYourPeak applies measurable, brain-based methods to real athlete performance.
          </p>

          <div className="badges">
            <span className="badge">Measurement-led coaching</span>
            <span className="badge">Athlete-first systems</span>
            <span className="badge">Vision + cognition + motor integration</span>
            <span className="badge">Built for competitive sport</span>
          </div>
        </div>

      </div>

    
  </div>
</div>
    {/* ================= FINAL CTA ================= */}

<div className="section">
  <div className="pad cta-box">
    

      <h2>Start Structured. Improve Faster.</h2>

      <p className="cta-sub">
        If you want random drills, the internet is full of them.
        If you want a system that improves performance, start here.
      </p>

      <div className="cta-buttons">
        <Link className="cta-primary" to="/webinar">
            🎥 Join Free Webinar
        </Link>

        <Link to="/ignite#waitlist" className="cta-secondary">
            Join Ignite Waitlist
        </Link>
            </div>

      

    
  </div>
</div>
      <div className="footer">© ForgeYourPeak • Why Us</div>
    </div>
  );
};

export default WhyUs;